<script setup lang="ts">
import { computed } from 'vue'

import {
  useEvent,
  useParticipantResult,
} from '@desktop/views/Relation/composables'
import { injectResultWithSliderConfig } from '@desktop/views/Relation/Sports/provide-inject'

const { getHomeParticipantResult, getAwayParticipantResult } =
  useParticipantResult()
const { event } = useEvent()

const { eventStatusToResultIdMap } = injectResultWithSliderConfig()!

const currentResultId = computed(() =>
  eventStatusToResultIdMap.get(event.value.status_id),
)

const homeResult = computed(() =>
  getHomeParticipantResult(currentResultId.value || null),
)
const awayResult = computed(() =>
  getAwayParticipantResult(currentResultId.value || null),
)
</script>

<template>
  <div class="text-center text-2xl font-bold text-nowrap select-none">
    {{ homeResult }} : {{ awayResult }}
  </div>
</template>
